import { isFinite, isNumber } from 'lodash';
import React, { useCallback } from 'react';

import { Box, Button, CircularProgress } from '@mui/material';

import { MayBeNil } from 'app/@types/utils/may-be-nil';
import groupDigits from 'utils/group-digits';

import useStyles from './styles';

const ALL = 'All';
const ALPHABET = Array.from({ length: 26 }, (_, n) => String.fromCharCode(97 + n));
const NUMBERS = Array.from({ length: 10 }, (_, n) => String(n));
const SPECIALS = [',', '@'];

const OPTIONS = [ALL, ...ALPHABET, ...NUMBERS, ...SPECIALS];

interface Props {
    selected?: string;
    onSelect?: (value: string) => void;
    getOptionHref?: (value: MayBeNil<string>) => string;
    total?: number;
    className?: string;
}

const LetterFilter: React.FC<Props> = ({ selected, onSelect, getOptionHref, total, className }) => {
    const { classes, cx } = useStyles();

    const handleSelect = useCallback(
        (event) => {
            event.preventDefault();
            const { option } = event.currentTarget.dataset;
            const value = option === ALL ? '' : option.toLowerCase();
            onSelect && onSelect(value);
        },
        [onSelect]
    );

    return (
        <Box className={cx(classes.container, className)}>
            {OPTIONS.map((option) => {
                const additional = getOptionHref
                    ? { component: 'a', href: getOptionHref(option === ALL ? null : option) }
                    : {};
                return (
                    <Button
                        key={option}
                        className={cx(classes.button, {
                            [classes._selected]: option === (selected || ALL),
                            [classes._wide]: option === ALL && isNumber(total)
                        })}
                        variant="outlined"
                        data-option={option}
                        onClick={handleSelect}
                        {...additional}
                    >
                        {option}
                        {option === ALL && isNumber(total) ? (
                            <span className={classes.total}>
                                {isFinite(total) ? (
                                    groupDigits(total)
                                ) : (
                                    <CircularProgress size={14} thickness={4} color="inherit" />
                                )}
                            </span>
                        ) : null}
                    </Button>
                );
            })}
        </Box>
    );
};

export default LetterFilter;
